export default class User {
    constructor({
                    id,
                    email,
                    first_name,
                    avatar_url,
                }) {
        this.id = id;
        this.email = email;
        this.first_name = first_name;
        this.avatarUrl = avatar_url;
        Object.freeze(this);
    }

    get displayName() {
        return this.first_name || this.email;
    }

    get initials() {
        return this.displayName
            .split(" ")
            .map((part) => part[0])
            .join("")
            .toUpperCase();
    }

    get hasAvatar() {
        return !!this.avatarUrl;
    }
}
